module.exports = __webpack_public_path__ + "static/who-we-are-hero-mobile.a409e5f7.webp";